import requests from "./httpServices";
import axios from 'axios';

const ProductServices = {
  getShowingProducts() {
    return requests.get("/products/show");
  },

  getDiscountedProducts() {
    return requests.get("/products/discount");
  },
  getAvailableProducts() {
    return requests.get("/products/available");
  },
  getBestSellProducts() {
    return requests.get("/products/bestsell");
  },
  getLatestProducts() {
    return requests.get("/products/latest");
  },

  getProductBySlug(slug) {
    return requests.get(`/products/${slug}`);
  },
  getProductBySku(sku) {
    return requests.get(`/products/sku/${sku}`);
  },
  searchProduct(body) {
    return requests.post(`/products/query/search`, { query: body });
  },
  searchProductBytags(body) {
    return requests.post(`/products/tag/search`, body);
  },
  search20ProductBytags(body) {
    return requests.post(`/products/tag/search20`, body);
  },
  getProducttitleFromSku(body) {
    return requests.patch(`/products/sku/title`, body);
  },
  // Modified to use relative URL
  searchProductWithMultiFacets: async (params) => {
    try {
      const response = await axios.post(
        `/api/search`,
        {
          multiSearch: true,
          searches: params.searches
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error searching products with multi-facets:', error);
      return { results: [] };
    }
  },
};

export default ProductServices;
